module.exports = global["$!expose-loader?jQuery"] = require("-!/var/www/expocentr/httpdocs/node_modules/jquery/dist/jquery.js");


//////////////////
// WEBPACK FOOTER
// /var/www/expocentr/httpdocs/~/jquery/dist/jquery.js
// module id = 2
// module chunks = 1